<template>
  <div class="collapsable">
    <div class="collapsable__header" @click="toggleCollapse()">
      <div class="collapsable__header__title">{{ title }}</div>
      <button class="collapsable__header__button" type="button">
        {{ collapsed ? "⇣" : "⇡" }}
      </button>
    </div>
    <transition name="fade-and-slide">
      <div class="uncollapsed" v-if="!collapsed"><slot></slot></div>
    </transition>
    <div @click="toggleCollapse()" class="collapsable-preview" v-if="collapsed">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Collapsable",
  props: ["toggleOnMount", "title"],
  data() {
    return {
      collapsed: true
    }
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed
      this.$ga.event({
        eventCategory: "collapsable",
        eventAction: "toggle"
      })
    }
  },
  mounted() {
    if (this.toggleOnMount) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.collapsed = false
          })
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../style/variables.scss";

.collapsable {
  margin-bottom: 20px;
  font-family: monospace;
  background-color: $color-dark;
  padding: 10px;
  width: 100%;
  position: relative;
  padding-bottom: 35px;
  box-shadow: $box-shadow-dark-md;
  border-radius: 0 0 $border-radius-md $border-radius-md;
}

.collapsable__header__button {
  border: 0;
  padding: 0;
  box-shadow: none;
  margin-left: auto;
  font-size: 1.2em;
  border-radius: 50%;
  font-weight: bold;

  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 30px;
  min-height: 30px;
  max-width: 30px;
  max-height: 30px;
  font-family: initial;
  color: $color-white;
  background: none;
}

.collapsable__header__button > * {
  border: 1px solid blue;
}

.collapsable__header {
  width: 100%;
  display: flex;
  align-items: center;
}

.collapsable-preview {
  margin-right: 10px;
  position: absolute;
  overflow: hidden;
  max-height: 35px;
  opacity: 0.3;
}

.collapsable__header__title {
  font-style: oblique;
  font-size: 1.2em;
  font-weight: bold;
}

.fade-and-slide-leave-active ~ .collapsable-preview {
  height: 0;
}

.fade-and-slide-enter-active {
  animation: fade-and-slide-in 0.5s ease-in;
}
.fade-and-slide-leave-active {
  animation: fade-and-slide-in 0.2s ease-in reverse;
}
@keyframes fade-and-slide-in {
  0% {
    opacity: 0.3;
    height: 0;
  }
  50% {
    opacity: 0.5;
    height: 50%;
  }
  100% {
    opacity: 1;
    height: 100%;
  }
}

@media (max-width: 767px) {
  .collapsable {
    width: auto;
    align-self: stretch;
  }
}
</style>
